import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "components/main";
import Scoreboard from "components/scoreboard";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />}></Route>
        <Route path="scoreboard" element={<Scoreboard />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
